"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldIndicator = /*#__PURE__*/function (_Entry$Field) {
  function FieldIndicator(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldIndicator);
    _this = _callSuper(this, FieldIndicator, [content, blockView, index]);
    _this._block = blockView.block;
    _this._blockView = blockView;
    var box = new Entry.BoxModel();
    _this.box = box;
    _this._size = content.size;
    if (content.img) {
      if (_this._block.deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN) {
        _this._imgUrl = content.img.replace('.png', '_un.png');
      } else {
        _this._imgUrl = content.img;
      }
    } else if (content.color) {
      _this._color = content.color;
    }
    _this._boxMultiplier = content.boxMultiplier || 2;
    _this._highlightColor = content.highlightColor || '#F59900';
    _this._position = content.position;
    _this._index = index;
    _this.svgGroup = null;
    _this._imgElement = null;
    _this.setValue(null);
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldIndicator, _Entry$Field);
  return (0, _createClass2["default"])(FieldIndicator, [{
    key: "renderStart",
    value: function renderStart() {
      var options;
      if (!this._imgElement) {
        this.svgGroup = this._imgElement = this._blockView.contentSvgGroup.elem('image');
      }
      if (this._imgUrl) {
        options = {
          href: Entry.mediaFilePath + this._imgUrl,
          x: this._position ? this._size * -1 : 0,
          y: this._size * -1,
          width: this._size * 2,
          height: this._size * 2
        };
        this._imgElement.attr(options);
        if (this._block.emphasized && this._imgUrl.lastIndexOf('_un.png') === -1) {
          this._imgUrl = this._imgUrl.replace('.png', '_un.png');
        }
      }
      this.box.set({
        width: this._size * this._boxMultiplier + (this._position ? -this._size : 0),
        height: this._size * this._boxMultiplier
      });
    }
  }, {
    key: "enableHighlight",
    value: function enableHighlight() {
      return;
      var pathLen = this._path.getTotalLength();
      var path = this._path;
      this._path.attr({
        stroke: this._highlightColor,
        strokeWidth: 2,
        'stroke-linecap': 'round',
        'stroke-dasharray': "".concat(pathLen, " ").concat(pathLen),
        'stroke-dashoffset': pathLen
      });
      setInterval(function () {
        path.attr({
          'stroke-dashoffset': pathLen
        }).animate({
          'stroke-dashoffset': 0
        }, 300);
      }, 1400, mina.easeout);
      setTimeout(function () {
        setInterval(function () {
          path.animate({
            'stroke-dashoffset': -pathLen
          }, 300);
        }, 1400, mina.easeout);
      }, 500);
    }
  }]);
}(Entry.Field);